import { useTranslation } from 'react-i18next';

export default function FAQSection() {
  const { t } = useTranslation();

  const faqs = [
    {
      q: '如何找到g点网官方入口？',
      a: '您可以直接通过浏览器访问g点网官方网站，建议收藏官方网址以备快速访问。在搜索引擎中搜索"g点网官方入口"也可快速定位到正确的官方站点。请认准官方认证标识，以防误入仿冒网站。',
    },
    {
      q: 'g点网支持哪些注册方式？',
      a: 'g点网支持手机号注册、邮箱注册以及微信、QQ等第三方账号快捷登录。新用户注册后可享受基础免费服务，如需更多高级功能可选择升级为付费会员。',
    },
    {
      q: '忘记密码如何找回？',
      a: '在登录页面点击"忘记密码"，通过绑定的手机号码或电子邮箱接收验证码，验证通过后即可设置新密码。如遇到任何困难，可联系官方客服获取人工协助。',
    },
    {
      q: 'g点网如何保障用户信息安全？',
      a: 'g点网采用银行级数据加密技术，所有用户信息均经过严格加密存储。平台通过了多项安全认证，并定期进行安全审计。建议用户开启双重认证功能，进一步提高账号安全等级。',
    },
    {
      q: 'g点网是否收费？',
      a: 'g点网基础服务完全免费，包括资讯浏览、社区互动、基础安全防护等功能。同时提供付费会员服务，会员可享受去广告、专属内容、优先客服等增值权益。',
    },
    {
      q: '如何联系g点网客服？',
      a: '您可以通过以下方式联系我们的客服团队：发送邮件至 service@gpoint.com，或拨打客服热线 400-888-9999。在线客服工作时间为周一至周五 9:00-18:00。',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            {t('faqTitle')}
          </h2>
          <p className="text-sm text-foreground-500">{t('faqSubtitle')}</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-50 border border-secondary-200 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-4 cursor-pointer text-foreground-900 font-medium text-sm hover:text-primary-600 transition-colors marker:content-none">
                <span>{faq.q}</span>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </summary>
              <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}